module.exports = __webpack_public_path__ + "img/team1.3c580942.jpg";